// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGVideoFile = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#videoFile__clip0_6435_5117)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M39.949 12.135c-.038-.183-.096-.346-.172-.497l.005.011v-.11c-.099-.165-.214-.306-.346-.43l-.001-.001L28.744.417c-.121-.106-.259-.199-.406-.273l-.01-.005h-.112c-.115-.056-.248-.103-.389-.136L27.813 0H13.998C10.733 0 8.078 2.608 8 5.852v4.867c-4.597.96-8 4.98-8 9.795C0 25.33 3.403 29.35 7.935 30.3L8 30.31v4.165c0 3.138 2.472 5.332 5.998 5.332h19.994c3.527 0 5.998-2.194 5.998-5.332V12.524c.006-.058.01-.126.01-.194 0-.069-.003-.137-.01-.203v.008h-.041zM6.667 15.537l1.389.763 7.997 4.61L12 23.23 8 25.548l-1.388.763.055-10.774zm29.325 18.98c0 1.097-1.084 1.388-2 1.388H13.998c-.916 0-1.999-.236-1.999-1.388v-4.165c4.597-.961 8-4.98 8-9.796 0-4.815-3.403-8.835-7.935-9.784L12 10.76V5.859c0-1.104.896-2 2-2h11.33v7.332c0 1.84 1.492 3.332 3.331 3.332h7.332v19.994z"
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "videoFile__clip0_6435_5117",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h40v40H0z"
      })
    })
  })]
}));
SVGVideoFile.displayName = 'SVGVideoFile';
export default SVGVideoFile;